<ham-table-with-actions
    [dataSource]="data"
    [pageSize]="10"
    [menuItems]="menuOptions"
    (rowSelected)="onRowButtonClicked($event)"
    (menuOptionClicked)="onMenuItemClick($event)"
    (checkBoxSelectionChanged)="onCheckBoxSelectionChanged($event)"
>
    <ng-template hamHeaderCell hamTextCol> {{ 'aumico_annual_report_table_label_company' | i18next }} </ng-template>
    <ng-template hamHeaderCell hamTextCol>
        {{ 'aumico_annual_report_table_label_current_year_date' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell hamDateCol>
        {{ 'aumico_annual_report_table_label_previous_year_date' | i18next }}
    </ng-template>
    <ng-template hamHeaderCell hamTextCol> {{ 'aumico_annual_report_table_label_language' | i18next }} </ng-template>
    <ng-template hamHeaderCell hamDateCol> {{ 'aumico_annual_report_table_label_currency' | i18next }} </ng-template>
    <ng-template hamHeaderCell hamTextCol> {{ 'aumico_annual_report_table_label_created_on' | i18next }} </ng-template>
    <ng-template hamHeaderCell hamTextCol> {{ 'aumico_annual_report_table_label_last_change' | i18next }} </ng-template>

    <ng-template hamCell let-element hamTextCol>
        {{ element?.company || '-' }}
        <span *ngIf="element.isSealed" class="ham-badge" hamBadge [hasCancelIcon]="false">
            {{'aumico_annual_report_fs_overview_sealed_tag' | i18next}}
        </span>
    </ng-template>
    <ng-template hamCell let-element hamDateCol> {{ (element?.currentYearDate | dateLocale) || '-' }} </ng-template>
    <ng-template hamCell let-element hamDateCol>
        {{ element?.previousYearDate ? (element.previousYearDate | dateLocale) : '-' }}
    </ng-template>
    <ng-template hamCell let-element hamTextCol> {{ element?.locale || '-' }} </ng-template>
    <ng-template hamCell let-element hamTextCol> {{ element?.currency || '-' }} </ng-template>
    <ng-template hamCell let-element hamDateCol> {{ (element?.createdAt | dateLocale) || '-' }} </ng-template>
    <ng-template hamCell let-element hamTextCol> {{ (element?.updatedAt | dateLocale) || '-' }} </ng-template>
</ham-table-with-actions>
